import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import Footer from './Footer';
import { useTheme } from '../../contexts/ThemeContext';
import { useFullScreen } from '../../contexts/FullScreenContext';

interface DashboardLayoutProps {
  children: React.ReactNode;
}

export default function DashboardLayout({ children }: DashboardLayoutProps) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { theme } = useTheme();
  const { isFullScreen } = useFullScreen();

  return (
    <div className={`flex h-screen ${theme === 'dark' ? 'bg-gray-900' : 'bg-gray-100'}`}>
      {/* Sidebar - hidden on mobile, shown with overlay when menu clicked */}
      {!isFullScreen && (
        <>
          <div
            className={`fixed inset-0 bg-gray-600 bg-opacity-75 transition-opacity md:hidden ${
              isSidebarOpen ? 'opacity-100 z-40' : 'opacity-0 -z-10'
            }`}
            onClick={() => setIsSidebarOpen(false)}
          />
          
          <div
            className={`fixed inset-y-0 left-0 transform ${
              isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
            } md:relative md:translate-x-0 transition duration-200 ease-in-out z-50 ${
              theme === 'dark' ? 'bg-gray-800' : 'bg-white'
            }`}
          >
            <Sidebar />
          </div>
        </>
      )}

      {/* Main content area */}
      <div className="flex-1 flex flex-col min-w-0">
        {!isFullScreen && (
          <Header setIsSidebarOpen={setIsSidebarOpen} />
        )}

        {/* Main content with automatic scrolling */}
        <div className={`flex-1 flex flex-col overflow-hidden ${isFullScreen ? 'p-0' : ''}`}>
          <main className={`flex-1 overflow-auto ${isFullScreen ? 'p-0' : ''}`}>
            {children}
          </main>
          {!isFullScreen && <Footer />}
        </div>
      </div>
    </div>
  );
}